import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';


class CorporateAccountRequestStatusProvider extends BaseApi {}
export const apiProvider = new CorporateAccountRequestStatusProvider(DMS_MODULE, NAME);
